module.exports = __webpack_public_path__ + "img/main.418ae601.jpeg";